


























import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import NegotiationLog from "@/components/App/Modules/GMS/Applicant/Summary/NegotiationLog.vue";
import HeaderInfo from './HeaderInfo.vue';

@Component({
  components: {
    NegotiationLog,
    HeaderInfo
  }
})
export default class ActivityLogComponent extends Vue {
  @Prop() appInfo: any;
  @Prop() selectedApplication: any;
  log: any = [];

  /*** Get the neg log */
  mounted() {
    this.$services.summary
      .getNegotiationLog(this.selectedApplication)
      .then((resp) => {
        if (resp.Result === "OK") {
          if (resp.Record && resp.Record.length > 0) {
            this.log = resp.Record.slice(0, resp.Record.length - 1);
          } else {
            this.log = [];
          }
        }
      });
  }

  ifFeedback(value) {
    if(value.target.checked === true) {
      this.$services.summary
      .getNegotiationLog(this.selectedApplication)
      .then((resp) => {
        if (resp.Result === "OK") {
          if (resp.Record && resp.Record.length > 0) {
            this.log = resp.Record.filter(x => x.Type === 'Feedback')
          } else {
            this.log = []
          }
        }
      })
    } else {
      this.$services.summary
      .getNegotiationLog(this.selectedApplication)
      .then((resp) => {
        if (resp.Result === "OK") {
          if (resp.Record && resp.Record.length > 0) {
            this.log = resp.Record.slice(0, resp.Record.length - 1)
          } else {
            this.log = []
          }
        }
      })
    }
  }

  /** Check whether negotiation log exists */
  get showNegotiationLog() {
    if (this.appInfo.WorkflowInfo && this.appInfo.WorkflowInfo.LogStatus) {
      const log = this.appInfo.WorkflowInfo.LogStatus.find(
        (x) =>
          x.WorkflowService === "Waiting Negotiation Response Business Rule"
      );

      if (this.appInfo.WorkflowInfo.LogStatus.length > 0) return true;
      else return false;
    } else {
      return false;
    }
  }
}
